import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  constructor(private userService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  //userUrl='http://192.241.151.66:5000/viewLogin'
  //deleteUrl="http://192.241.151.66:5000/viewLogin/"
  output:any=[]
  alert=""
  UserId=""
  UserName=""
  admin:any=[]
  New_count=0;
  count=0;
  next_output:any=[];
  loaderShown=true;
  cardShown=false;
  search: string = '';
  isTemp: boolean = false;
  drop:string = this.userService.userListFilter
  btnClick(){
    this.router.navigateByUrl(('admin/create-user'));  
  
  }

    //-------------function for search--------------------
Search(){
  console.log("click search =",this.search,this.drop);
  this.userService.userListFilter = this.drop
  console.log('from service',this.userService.userListFilter);
  
  // if(this.search =='' && this.drop == "")
  //   {
  //     this.userService.ViewUsers(this.count).subscribe((res)=>{
  //       this.output=res.data
  //     })

  //   }
  //   else{
    this.count = 0
   //-------api get()calling-------------
   this.userService.SearchUser(this.search,this.drop,this.count,this.isFactoryManager,this.isTemp).subscribe((res)=>{
   this.output=res.data
   console.log("click search",res.data);
  })
// }
}


//-----------function for set id of deleting user------------
SetUser(Id:any,name:any){

  this.UserId=Id
  this.UserName=name
}

//---------function for delete a user-----------------------
  DeleteUser()
 {
   //-------api delete user-------------
   this.userService.DeleteUser(this.UserId).subscribe((res)=>{
   this.alert=res.message

   //------------call api for display the new list-------------
   this.ngOnInit();
    })
  
 }
  //------function for routing-------------------------
  UserDetails(){
    console.log("Clicked")
    this.router.navigateByUrl(('admin/single-user-detail'));  
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  //-----function for urouting to edit user details---------
  EditDetails(){

    console.log("Clicked")
    this.router.navigateByUrl(('admin/edit-user'));  
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }
  
  //--------function set user id---------
  getValue = (item : string) =>{
     
    this.userService.setUserId(item)
    console.log("error=",item)
  
  }
  //----paging previous----------
  clicks_previous(){
    if(this.New_count==0){
      return;
    }

    else{
      this.New_count=this.New_count-1;
      this.count=this.New_count; 
    }
this.userService.SearchUser(this.search,this.drop,this.count,this.isFactoryManager,this.isTemp).subscribe((res)=>{
     
      if(res.data[0].username=='admin'){

        this.output=res.data.slice(1)

      }
      else{
        this.output=res.data
      }
    })

  }
  //------paging next--------------
  clicks_next(){

    this.count=this.count+1
this.userService.SearchUser(this.search,this.drop,this.count,this.isFactoryManager,this.isTemp).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })



  }

  isFactoryManager:boolean = false;

  ngOnInit(): void {

    const userType = localStorage.getItem('userTypecon');
    if (userType?.toUpperCase() == 'FACTORY_MANAGER') {
      this.isFactoryManager = true;
    }else{
      this.isFactoryManager = false;
    }
    // debugger
    

    if(this.drop !=""){
      this.userService.showToast('warning','Filters are active')
    }
this.userService.SearchUser(this.search,this.drop,this.count,this.isFactoryManager,this.isTemp).subscribe((res)=>{
    this.output=res.data
    this.admin=this.output[0]
    // this.output=this.output.slice(1)
// debugger
    this.loaderShown=false;
    this.cardShown=true;
  
    console.log("output=",this.output)
    this.getUsertype()

    })
  }
  userTypedropdown:any
  getUsertype(){
    this.userService.usertypeDropdown().subscribe((res) => {
      this.userTypedropdown = res.data
    })
  }

  // Navigate to Create User page
navigateToCreateUser() {
  this.router.navigateByUrl('admin/create-user');
}

// Navigate to Create Temporary User page
navigateToCreateTempUser() {
  this.router.navigateByUrl('admin/create-temp-user');
}

toggleTempFilter() {
  this.isTemp = !this.isTemp;
  this.count = 0;
  this.Search();
}

}
